/**
 * @copyright Copyright 2023 Epic Systems Corporation
 * @file constants
 * @module Epic.AppOrchard.Data.Constants
 */

export const UsCountryId = 2840;
/**
 * C# max int value
 */
export const MaxIntValue = 2147483647;
